// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
// 最老版-11月版
import router from "./router";
// 20年5月版
// import router from './router/router'
import store from "./store";
import "./utils/util";
import "../src/style/common.less";
import "./style/font/font.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "animate.css";
import "swiper/css/swiper.css";
// SEO mate标签设置
import MetaInfo from "vue-meta-info";
import AFTableColumn from "af-table-column";
Vue.use(MetaInfo);

const redirectDataWebsiteHome = () => {
  const path = window.location.pathname.replace(/\/$/, "");
  const hashPath = window.location.hash.split("?")[0];

  if (path === "/data-website" && (hashPath === "" || hashPath === "#/")) {
    const hostSuffix = process.env.HOST === "prod" ? "" : "-test";
    window.location.replace(`https://www${hostSuffix}.wfq2020.com/`);
    return true;
  }

  return false;
};

const isRedirectingFromDataWebsiteHome = redirectDataWebsiteHome();

// Vue.use(BootstrapVue)
Vue.use(VueAwesomeSwiper);
Vue.use(ElementUI);
Vue.use(AFTableColumn);
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
import "./views/demo/assets/china.js";

Vue.prototype.$filterNull = item => {
  for (const attr in item) {
    if (item[attr] === "" || item[attr] === null) {
      item[attr] = "---";
    }
  }
};
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */
  if(to.meta.content){
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  // /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next()
});

// 引入lodash 函数
const _ = require("lodash");
Vue.prototype._ = _;

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  // if (to.path) {
  //   //   window._hmt.push(['_trackPageview', '/#' + to.fullPath])
  //   // }
  next();
});

Vue.prototype.$reportFilterNull = list => {
  if (!Array.isArray(list)) return;
  return list.map(item => {
    for (const key in item) {
      item[key] = ["", null, undefined].includes(item[key]) ? "--" : item[key];
    }
    return item;
  });
};

let app = null;
if (!isRedirectingFromDataWebsiteHome) {
  app = new Vue({
    el: "#app",
    router,
    store: store,
    components: {
      App
    },
    template: "<App/>",
    mounted() {
      document.dispatchEvent(new Event("render-event"));
    }
  });
}
export default app;

(function(window, document) {
  const resizeEvt =
    "orientationchange" in window ? "orientationchange" : "resize";
  let recalcFun = function() {
    // console.log(store)
    const isTrue = document.documentElement.clientWidth < 760;
    store.dispatch("setMobile", isTrue);
  };
  window.addEventListener(resizeEvt, recalcFun, false);
  document.addEventListener("DOMContentLoaded", recalcFun, false);
})(window, document);



// WEBPACK FOOTER //
// ./src/main.js